import { gql } from '@apollo/client';

export const GET_TEST_SESSION_NOTE = gql`
  query GetClip($id: ID!) {
    testSessionNote(id: $id) {
      id
      note
      videoUrl
      status
      testSession {
        id
        tester {
          id
          project {
            name
          }
          user {
            id
            profile {
              id
              firstName
            }
          }
        }
      }
    }
  }
`;
